import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Colors, ColorsType, Radius, Spacing } from '@common/tokens';

export type BoxProps = PropsWithChildren<{
  color?: ColorsType;
  className?: string;
  dataTestId?: string;
}>;

export const Box = ({
  color = 'steelLighter',
  className,
  children,
  dataTestId,
}: BoxProps) => (
  <>
    <div className={clsx('wk-box', className)} data-testid={dataTestId}>
      {children}
    </div>
    <style jsx>{`
      .wk-box {
        display: inline-block;
        padding: ${Spacing.sm}px ${Spacing.md}px;
        border-radius: ${Radius.sm};
        background-color: ${Colors[color]};
      }
    `}</style>
  </>
);
